import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import orderBy from 'lodash/orderBy'
import findIndex from 'lodash/findIndex'
import Chart from 'chart.js'
import 'chartjs-plugin-datalabels'

class EmployeeTypeChart extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (JSON.stringify(get(nextProps, 'data')) !== JSON.stringify(prevState.data)) {
      const data = get(nextProps, 'data')
      const fullTime = []
      const partTime = []
      const subcontract = []
      const trainee = []
      const total = []
      Object.keys(get(data, ['0'], [])).forEach(key => {
        if (key !== 'emp_type') {
          fullTime.push({ lob: key, value: data[0][key] })
        }
      })
      Object.keys(get(data, ['1'], [])).forEach(key => {
        if (key !== 'emp_type') {
          partTime.push({ lob: key, value: data[1][key] })
        }
      })
      Object.keys(get(data, ['2'], [])).forEach(key => {
        if (key !== 'emp_type') {
          subcontract.push({ lob: key, value: data[2][key] })
        }
      })
      Object.keys(get(data, ['3'], [])).forEach(key => {
        if (key !== 'emp_type') {
          trainee.push({ lob: key, value: data[3][key] })
        }
      })
      if (get(data, ['4'])) {
        Object.keys(get(data, ['4'], [])).forEach(key => {
          if (key !== 'gender') {
            total.push({ lob: key, value: data[4][key] })
          }
        })
      } else {
        for (let i = 0; i < fullTime.length; i++) {
          const sum = fullTime[i].value
          + partTime[i].value
          + subcontract[i].value
          + trainee[i].value
          total.push({ lob: fullTime[i].lob, value: sum })
        }
      }
      const labels = []
      let totalData = orderBy(total, 'lob', 'asc')
      const totalIndex = findIndex(totalData, { lob: 'total' })
      // total
      if (totalIndex > -1) {
        const tempTotal = totalData[totalIndex]
        totalData.splice(totalIndex, 1)
        totalData.splice(totalData.length, 0, tempTotal)
      }
      totalData = totalData.map(lob => {
        labels.push(get(lob, 'lob'))
        return get(lob, 'value')
      })
      // Full-Time
      const fullTimeData = orderBy(fullTime, 'lob', 'asc')
      const totalIndexFull = findIndex(fullTimeData, { lob: 'total' })
      if (totalIndexFull > -1) {
        const tempTotalFull = fullTimeData[totalIndexFull]
        fullTimeData.splice(totalIndexFull, 1)
        fullTimeData.splice(fullTimeData.length, 0, tempTotalFull)
      }
      let fullTimePercent = [...fullTimeData]
      fullTimePercent = fullTimePercent.map((lob, index) => {
        return totalData[index] !== 0 ? parseFloat((get(lob, 'value') / totalData[index]) * 100).toFixed(2) : '0.00'
      })
      // Part-Time
      const partTimeData = orderBy(partTime, 'lob', 'asc')
      const totalIndexPart = findIndex(partTimeData, { lob: 'total' })
      if (totalIndexPart > -1) {
        const tempTotalPart = partTimeData[totalIndexPart]
        partTimeData.splice(totalIndexPart, 1)
        partTimeData.splice(partTimeData.length, 0, tempTotalPart)
      }
      let partTimePercent = partTimeData
      partTimePercent = partTimePercent.map((lob, index) => {
        return totalData[index] !== 0 ? parseFloat((get(lob, 'value') / totalData[index]) * 100).toFixed(2) : '0.00'
      })
      // Subcontract
      const subcontractData = orderBy(subcontract, 'lob', 'asc')
      const totalIndexSub = findIndex(subcontractData, { lob: 'total' })
      if (totalIndexSub > -1) {
        const tempTotalSub = subcontractData[totalIndexSub]
        subcontractData.splice(totalIndexSub, 1)
        subcontractData.splice(subcontractData.length, 0, tempTotalSub)
      }
      let subcontractPercent = subcontractData
      subcontractPercent = subcontractPercent.map((lob, index) => {
        return totalData[index] !== 0 ? parseFloat((get(lob, 'value') / totalData[index]) * 100).toFixed(2) : '0.00'
      })
      // Trainee
      const traineeData = orderBy(trainee, 'lob', 'asc')
      const totalIndexTrainee = findIndex(traineeData, { lob: 'total' })
      if (totalIndexTrainee > -1) {
        const tempTotalTrainee = traineeData[totalIndexTrainee]
        traineeData.splice(totalIndexTrainee, 1)
        traineeData.splice(traineeData.length, 0, tempTotalTrainee)
      }
      let traineePercenet = traineeData
      traineePercenet = traineePercenet.map((lob, index) => {
        return totalData[index] !== 0 ? parseFloat((get(lob, 'value') / totalData[index]) * 100).toFixed(2) : '0.00'
      })
      set(tempState, 'fullTimeData', fullTimeData)
      set(tempState, 'fullTimePercent', fullTimePercent)
      set(tempState, 'partTimeData', partTimeData)
      set(tempState, 'partTimePercent', partTimePercent)
      set(tempState, 'subcontractData', subcontractData)
      set(tempState, 'subcontractPercent', subcontractPercent)
      set(tempState, 'traineeData', traineeData)
      set(tempState, 'traineePercenet', traineePercenet)
      set(tempState, 'labels', labels)
      set(tempState, 'data', get(nextProps, 'data'))
    }
    return tempState
  }

  state={}

  componentDidMount() {
    this.forceUpdate()
  }

  renderChart = () => {
    const {
      labels, fullTimeData, partTimeData, subcontractData, traineeData,
      fullTimePercent, partTimePercent, subcontractPercent, traineePercenet,
    } = this.state
    const chart = document.getElementById(get(this.props, 'idchart')).getContext("2d")
    // eslint-disable-next-line no-new
    new Chart(chart, {
      type: 'bar',
      data: {
        labels,
        datasets: [{
          label: "Full-Time",
          id: "y-axis-0",
          yAxisID: 'y-axis-0',
          type: "bar",
          backgroundColor: "#FFA600",
          data: fullTimePercent,
        }, {
          label: "Part-Time",
          id: "y-axis-0",
          yAxisID: 'y-axis-0',
          type: "bar",
          backgroundColor: "#BC5090",
          data: partTimePercent,
        }, {
          label: "Subcontractor",
          id: "y-axis-0",
          yAxisID: 'y-axis-0',
          type: "bar",
          backgroundColor: "#374C80",
          data: subcontractPercent,
        }, {
          label: "Trainee",
          id: "y-axis-0",
          yAxisID: 'y-axis-0',
          type: "bar",
          backgroundColor: "#F95D6A",
          data: traineePercenet,
        },
        ],
      },
      options: {
        layout: {
          padding: {
            top: 15,
          },
        },
        legend: {
          position: 'bottom',
          labels: {
            boxWidth: 15,
          },
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
        maintainAspectRatio: false,
        tooltips: {
          mode: 'label',
          callbacks: {
            label: (tooltipItem, data) => {
              const dataIndex = tooltipItem.datasetIndex
              const index = tooltipItem.index
              let rawData
              switch (dataIndex) {
                case 0: {
                  rawData = fullTimeData
                  break
                }
                case 1: {
                  rawData = partTimeData
                  break
                }
                case 2: {
                  rawData = subcontractData
                  break
                }
                case 3: {
                  rawData = traineeData
                  break
                }
                default: break
              }
              return `${data.datasets[dataIndex].label}: ${get(rawData, [index, 'value'])} (${data.datasets[dataIndex].data[index]}%)`
            },
          },
        },
        chartArea: {
          backgroundColor: '#EDEFF5',
        },
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              autoSkip: false,
            },
          }],
          yAxes: [{
            stacked: true,
            position: "left",
            id: "y-axis-0",
            ticks: {
              min: 0,
              max: 100,
              stepSize: 25,
              callback: (value) => {
                return `${value}%`
              },
            },
          }],
        },
      },
    })
  }

  render() {
    if (document.getElementById(get(this.props, 'idchart')) !== null) {
      this.renderChart()
    }
    return (
      <Wrapper>
        <canvas id={ get(this.props, 'idchart') } width='100%' height={ 300 } />
      </Wrapper>
    )
  }
}

export default EmployeeTypeChart

const Wrapper = styled.div`
  width: 100%;
  background-color: #ffffff;
`



// WEBPACK FOOTER //
// ./src/components/report/charts/headcount/employee-type-chart.js